import { PAGE_TEMPLATES, COMPONENT_TEMPLATES } from "./utils/constants/templates";
import { environment } from "./environment";
import Standard from "./pages/magnolia/standard/Standard";
import ProductOverview from "./pages/magnolia/productOverview/ProductOverview";
import ProductDetail from "./pages/magnolia/productDetail/ProductDetail";
import ComponentFactoryItem from "./pages/magnolia/componentFactory/ComponentFactoryItem";
import Hero from "./components/magnolia/hero/Hero";
import HeroSlide from "./components/magnolia/hero/HeroSlide";
import Headline from "./components/magnolia/Headline";
import ComponentFactoryLink from "./components/magnolia/componentFactory/ComponentFactoryLink";

export const componentMappings = {
    [PAGE_TEMPLATES.HOME]: Standard,
    [PAGE_TEMPLATES.STANDARD]: Standard,
    [PAGE_TEMPLATES.PRODUCT_OVERVIEW]: ProductOverview,
    [PAGE_TEMPLATES.PRODUCT_DETAIL]: ProductDetail,
    [COMPONENT_TEMPLATES.HERO]: Hero,
    [COMPONENT_TEMPLATES.HERO_SLIDE]: HeroSlide,
    [COMPONENT_TEMPLATES.HEADLINE]: Headline,

    // Component Factory. Both ids come from the environment because the templates live in a
    // project light module rather than in this app: a project that renames them, or installs
    // no Component Factory at all, needs no change here. The first renders a factory item on
    // its own (what the Pages app previews), the second renders one embedded in a page.
    [environment.COMPONENT_FACTORY_PAGE_TEMPLATE]: ComponentFactoryItem,
    [environment.COMPONENT_FACTORY_LINK_TEMPLATE]: ComponentFactoryLink,
};
